export const defaultReducer = (antState, newState) => {
    return { ...antState, ...newState }
}

export const lockedReducer = (state, action) => {
    const returnActions = Object.fromEntries(Object.entries(action).filter(([key, value]) => key in state))
    return { ...state, ...returnActions }
}


export const checkboxShiftReducer = (state, action) => {
    switch (action.type) {
        case "SET_SELECTED_ROWS": {
            return { ...state, selectedRows: new Set(action.payload) };
        }

        case "SHIFT_SELECT": {
            const { id, rows } = action.payload;
            const { selectedRows, lastSelected } = state;

            if (lastSelected === null) {
                return { ...state, selectedRows: new Set([id]), lastSelected: id };
            }

            const allIds = rows.map(row => row.id);
            const startIndex = allIds.indexOf(lastSelected);
            const endIndex = allIds.indexOf(id);
            const [min, max] = [startIndex, endIndex].sort((a, b) => a - b);
            const rangeIds = allIds.slice(min, max + 1);

            const allSelected = rangeIds.every(item => selectedRows.has(item));

            const newSelectedRows = new Set(selectedRows);
            if (allSelected) {
                rangeIds.forEach(item => newSelectedRows.delete(item));
            } else {
                rangeIds.forEach(item => newSelectedRows.add(item));
            }

            return { ...state, selectedRows: newSelectedRows, lastSelected: id };
        }

        case "TOGGLE_SELECT": {
            const { id } = action.payload;
            const newSelectedRows = new Set(state.selectedRows);
            if (newSelectedRows.has(id)) {
                newSelectedRows.delete(id);
            } else {
                newSelectedRows.add(id);
            }
            return { ...state, selectedRows: newSelectedRows, lastSelected: id };
        }

        default:
            return state;
    }
};


